'use strict';

var messaging = require('shared/messaging'),

    widgetMessagingChannels = require('widget/scripts/lib/commons/widgetMessagingChannels');

module.exports = function (widget, visualizationType, visualizationTypeOptions) {
    var channel = widgetMessagingChannels.get(widget.id),
        messageToSend,
        messageToSendData = {};

    if (!_isInDOM(widget)) {
        throw new Error('iVis.Widget: cannot request/update visualization as widget seams not be in DOM');
    }

    messageToSendData = {
        type: visualizationType,
        options: visualizationTypeOptions
    };

    messageToSend = messaging.generateMessage(
        widget.id,
        messaging.titles.GET,
        messageToSendData
    );

    channel.postMessage(messageToSend.message);

    return messageToSend.id;
};

function _isInDOM(widget) {
    return document.getElementById(widget.id) !== null;
}



//////////////////
// WEBPACK FOOTER
// ./src/widget/scripts/lib/commons/submitToReceiver.js
// module id = 19
// module chunks = 0 1